import React from 'react';
import PropTypes from 'prop-types';
import {CloseIcon} from '../Icons';
import {Image} from '@learningblocks/shared-components/lib/Image';
import './style.scss';

const ENTER_KEY_CODE = 13;
const SPACE_KEY_CODE = 32;

/**
 * The close button to be displayed with Modal Window
 */
export function CloseButton(props) {
  const keyDown = (event) => {
    if (event.keyCode === ENTER_KEY_CODE || event.keyCode === SPACE_KEY_CODE) {
      props.close(event);
    }
  };
  return (
    <div className={`closeButton-block ${props.className}`}>
      <span
        tabIndex='0'
        role='button'
        className={props.size}
        onKeyDown={keyDown}
        onClick={props.close}>
        Close
        <Image
          className='closeButton'
          src={CloseIcon}
          aria-label='Close button'
          alt='Close button'
        />
      </span>
    </div>
  );
}

CloseButton.propTypes = {
  /**
   * custom className to set for closeButton
   */
  className: PropTypes.string.isRequired,
  /**
   * callback function to be involked close button is clicked
   */
  close: PropTypes.func,
  /**
   * String value to specify the size of modal
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

CloseButton.defaultProps = {
  className: '',
  size: 'sm',
};
